<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                @if (error) {
                  <pr-color-panel [display]="'danger'">
                    <pr-panel-body clazz="pam">
                      <pr-label [name]="'error'" [width]="18" [height]="18">{{
                        error?.message
                      }}</pr-label>
                    </pr-panel-body>
                  </pr-color-panel>
                }
                <div class="col col-md-12">
                  <pr-input-column
                    label=" Quel montant souhaitez-vous investir ?"
                    [derrors]="derrors"
                  >
                    <input
                      notdot
                      formControlName="privateEquityInvestmentAmount"
                      type="number"
                      placeholder="Exemple : 100 000€"
                    />
                  </pr-input-column>
                </div>
                @if (
                  sessionConsultant &&
                  dispalyQuestion(
                    parameters,
                    'PRIVATE_EQUIT_TAX_REDUCTION_AMOUNT'
                  )
                ) {
                  <div class="col col-md-12">
                    <pr-input-column
                      label="Montant de la réduction d’impôts"
                      [derrors]="derrors"
                    >
                      <input
                        notdot
                        formControlName="privateEquityReductionAmount"
                        type="number"
                        placeholder="Exemple : 100 000€"
                      />
                    </pr-input-column>
                  </div>
                }
              </div>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
